

























import ConfirmModal from '@/components/common/ConfirmModal.vue';
import CardInformation from '@/components/form/CardInformation.vue';
import AcceptQuoteMutation from '@/graphql/mutations/acceptQuote.gql';
import QuoteQuery from '@/graphql/queries/quote.gql';
import { API_HOST, getAuthHeader, request } from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    CardInformation,
    ConfirmModal,
  },
})
export default class AcceptQuote extends Vue {
  public id: string = '';
  public quote: {
    id: string;
    state: string;
    price: number;
  } = {} as any;
  public errorMessage = '';
  public bus = new Vue();
  public disabled: boolean = false;
  public modalVisible: boolean = false;

  public acceptQuote() {
    this.modalVisible = false;
    this.disabled = true;
    this.bus.$emit('requestPaymentData');
  }

  public mounted() {
    this.id = this.$route.query.id;

    this.bus.$on(
      'paymentData',
      ({ token, name }: { token: string; name: string }) => {
        request(AcceptQuoteMutation, {
          quoteId: this.id,
          paymentToken: token,
          name,
        })
          .then(({ response, errors }: any) => {
            if (errors && errors.length) {
              throw errors;
            }
            this.quote.state = 'accepted';
            window.scrollTo(0, 0);
          })
          .catch(errors => {
            this.errorMessage = this.parseErrors(errors);
            this.disabled = false;
          });
      }
    );

    this.bus.$on('error', (message: string) => {
      this.errorMessage = message;
      this.disabled = false;
    });

    request(QuoteQuery, { id: this.id })
      .then(response => {
        if (!response || !response.data) {
          console.error('No clinic returned');
          return;
        }

        this.quote = response.data.quote;

        if (!this.quote) {
          this.$router.push('/');
        }
      })
      .catch(console.error);
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  private parseErrors(errors: any) {
    const err = errors && errors[0];
    if (!err) {
      return 'Something went wrong. Please try again later.';
    }

    const msg = err.message || err;
    return typeof msg === 'string'
      ? msg
      : msg.error || 'Something went wrong. Please try again later.';
  }
}
